import { render, staticRenderFns } from "./RangeSlider.vue?vue&type=template&id=56a57016&lang=pug"
import script from "./RangeSlider.vue?vue&type=script&lang=js"
export * from "./RangeSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports